import Vue from 'vue';
import {
  Button,
  Form,
  Field,
  Toast,
  Picker,
  Popup,
} from 'vant';
import { VueConstructor } from 'vue/types/umd';

function install(vue: VueConstructor) {
  vue.use(Button);
  vue.use(Form);
  vue.use(Field);
  vue.use(Picker);
  vue.use(Popup);
  // vue.use(Toast);
}
Vue.prototype.$toast = Toast;
// Vue.prototype.$message = message;
// Vue.prototype.$confirm = Modal.confirm;
export default install;
